import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class Arbeitsbereich {
  constructor({
    markierung,
    name,
    id,
    standort,
  }: {
    markierung: Markierung;
    standort: Standort;
    name: string;
    id: string;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.id = id;
    this.standort = standort;
  }

  id: string;
  standort: Standort;
  markierung: Markierung;
  name: string;

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }
}
